export const getPaymentType = (type: number) => {
  if (type === 0) {
    return 'QRCODE';
  }
  if (type === 1) {
    return 'CARTÃO DE TRANSPORTE';
  }

  if (type === 2) {
    return 'EMV';
  }

  if (type === 3) {
    return 'BOTOEIRA';
  }

  if (type === 4) {
    return 'ENTRADA EXTERNA';
  }

  if (type === 5) {
    return 'RECONHECIMENTO FACIAL';
  }

  if (type === 6) {
    return 'PIX';
  }

  return 'TIPO INDEFINIDO';
};
